/* A quiet, full-width trigger: a chevron, the text, then an optional summary at the end. */
.trigger {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  inline-size: 100%;
  min-block-size: 32px;
  padding: 0;
  border: 0;
  background: transparent;
  color: var(--text);
  font: inherit;
  font-size: var(--font-size-13);
  font-weight: var(--font-weight-medium);
  text-align: start;
  cursor: pointer;
}

.trigger:hover .label {
  text-decoration: underline;
  text-underline-offset: 2px;
}

.trigger:focus-visible {
  outline: 2px solid var(--focus-ring);
  outline-offset: 2px;
  border-radius: var(--radius-small);
}

.chevron,
.chevronOpen {
  display: inline-flex;
  color: var(--text-muted);
  transition: transform var(--motion-duration);
}

/* Closed it points right (more to see); open it points down, as `aria-expanded` says. */
.chevron {
  transform: rotate(-90deg);
}

.label {
  min-inline-size: 0;
}
